import { default as _advancedFilters } from './advancedFilters.json';
import { default as _agentBots } from './agentBots.json';
import { default as _agentMgmt } from './agentMgmt.json';
import { default as _attributesMgmt } from './attributesMgmt.json';
import { default as _automation } from './automation.json';
import { default as _bulkActions } from './bulkActions.json';
import { default as _webhooksSendMessages } from './webhooksSendMessages.json';
import { default as _campaign } from './campaign.json';
import { default as _cannedMgmt } from './cannedMgmt.json';
import { default as _chatlist } from './chatlist.json';
import { default as _closingReasons } from './closingReasons.json';
import { default as _campaignsReport } from './campaignsReport.json';
import { default as _c2wCampaignsReport } from './c2wCampaignsReport.json';
import { default as _callLogReport } from './callLogReport.json';
import { default as _apiErrorsReport } from './apiErrorsReport.json';
import { default as _templateEventsReport } from './templateEventsReport.json';
import { default as _whatsappConsumptionsReport } from './whatsappConsumptionsReport.json';
import { default as _virtualAssistantConsumptionsReport } from './virtualAssistantConsumptionsReport.json';
import { default as _agentBotManagement } from './agentBotManagement.json';
import { default as _operationalDashboard } from './operationalDashboard.json';
import { default as _labelsReport } from './labelsReport.json';
import { default as _ctwaHistory } from './ctwaHistory.json';
import { default as _conditions } from './conditions.json';
import { default as _contact } from './contact.json';
import { default as _contactFilters } from './contactFilters.json';
import { default as _conversation } from './conversation.json';
import { default as _csatMgmtMgmt } from './csatMgmt.json';
import { default as _generalSettings } from './generalSettings.json';
import { default as _inboxMgmt } from './inboxMgmt.json';
import { default as _internalChat } from './internalChat.json';
import { default as _integrationApps } from './integrationApps.json';
import { default as _integrations } from './integrations.json';
import { default as _labelsMgmt } from './labelsMgmt.json';
import { default as _productLabelsMgmt } from './productLabelsMgmt.json';
import { default as _topicLabelsMgmt } from './topicLabelsMgmt.json';
import { default as _concurrentLabelsMgmt } from './concurrentLabelsMgmt.json';
import { default as _login } from './login.json';
import { default as _macros } from './macros.json';
import { default as _report } from './report.json';
import { default as _resetPassword } from './resetPassword.json';
import { default as _scheduledMessage } from './scheduledMessage.json';
import { default as _setNewPassword } from './setNewPassword.json';
import { default as _settings } from './settings.json';
import { default as _signup } from './signup.json';
import { default as _teamsSettings } from './teamsSettings.json';
import { default as _templateParameterization } from './templateParameterization.json';
import { default as _whatsappTemplates } from './whatsappTemplates.json';
import { default as _helpCenter } from './helpCenter.json';
import { default as _dashboardApps } from './dashboardApps.json';
import { default as _securityPolicies } from './securityPolicies.json';
import { default as _blockAccessUserAccount } from './blockAccessUserAccount.json';
import { default as _priorityContact } from './priorityContact.json';
import { default as _upcomingScheduledMessages } from './upcomingScheduledMessages.json';
import { default as _builder } from './builder.json';
import { default as _search } from './search.json';
import { default as _cadencias } from './cadencias.json';
import { default as _events } from './events.json';
import { default as _call } from './call.json';
import { default as _subaccounts } from './subaccounts.json';
import { default as _opportunityPipelines } from './opportunityPipelines.json';
import { default as _opportunityDetails } from './opportunityDetails.json';

export default {
  ..._advancedFilters,
  ..._agentBots,
  ..._agentMgmt,
  ..._attributesMgmt,
  ..._automation,
  ..._webhooksSendMessages,
  ..._campaign,
  ..._cannedMgmt,
  ..._chatlist,
  ..._closingReasons,
  ..._labelsReport,
  ..._campaignsReport,
  ..._c2wCampaignsReport,
  ..._callLogReport,
  ..._apiErrorsReport,
  ..._templateEventsReport,
  ..._whatsappConsumptionsReport,
  ..._virtualAssistantConsumptionsReport,
  ..._agentBotManagement,
  ..._operationalDashboard,
  ..._ctwaHistory,
  ..._conditions,
  ..._contact,
  ..._contactFilters,
  ..._conversation,
  ..._csatMgmtMgmt,
  ..._generalSettings,
  ..._inboxMgmt,
  ..._internalChat,
  ..._integrationApps,
  ..._integrations,
  ..._labelsMgmt,
  ..._productLabelsMgmt,
  ..._topicLabelsMgmt,
  ..._concurrentLabelsMgmt,
  ..._login,
  ..._macros,
  ..._report,
  ..._resetPassword,
  ..._scheduledMessage,
  ..._setNewPassword,
  ..._settings,
  ..._signup,
  ..._teamsSettings,
  ..._templateParameterization,
  ..._whatsappTemplates,
  ..._bulkActions,
  ..._helpCenter,
  ..._dashboardApps,
  ..._securityPolicies,
  ..._blockAccessUserAccount,
  ..._priorityContact,
  ..._upcomingScheduledMessages,
  ..._builder,
  ..._search,
  ..._cadencias,
  ..._events,
  ..._call,
  ..._subaccounts,
  ..._opportunityPipelines,
  ..._opportunityDetails,
};
